<ng-container *transloco="let t; read: 'FORMULA_MODAL_COMPONENT'">
  <ion-content [scrollEvents]="formula.imageUrl" (ionScroll)="onScroll($event)">
    <div #formulaContainer class="formula-container" *ngLet="showDataInHeader$ | async as showDataInHeader">
      <!-- header -->
      <div class="formula-toolbar-header" [class.has-long-title]="titleEl?.nativeElement.offsetHeight > 26" #toolbar [class.show-title]="showDataInHeader">
        <ion-button (click)="dismissModal()" fill="none" color="secondary">
          <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
        <h1 #title>{{ formula.label }}</h1>
        <div class="right"></div>
      </div>
      <div class="formula-img-container" *ngIf="formula.imageUrl">
        <img class="formula-img" [src]="formula.imageUrl" />
      </div>

      <!-- content -->
      <div
        class="formula-detail-inner flex-column ion-padding"
        [class.has-long-title]="titleEl?.nativeElement.offsetHeight > 26"
        [class.no-image-margin]="!formula.imageUrl && showDataInHeader"
      >
        <h1 [class.hide]="showDataInHeader" *ngIf="formula.imageUrl" class="text-start mb-4">
          {{ formula.label }}
        </h1>
        <div class="formula-description mb-16">{{ formula.description }}</div>

        <form *ngIf="form" [formGroup]="form" class="flex-column" (ngSubmit)="addOrUpdateFormula()">
          <div formArrayName="sections">
            <div *ngFor="let section of sections.controls; let i = index" class="flex-column mb-24" [formGroupName]="i">
              <div class="section-title-container mb-8" *ngLet="dishCountIsValid(i) as dishCountIsValid">
                <div class="section-title">
                  {{ section.value?.label }}
                </div>
                <div class="required-chip" [class.warning]="!dishCountIsValid && section.value?.isRequired && showWarning">
                  <ng-container *ngIf="section.value?.isRequired; else optional">
                    {{ t('REQUIRED') }} ·
                    <ng-container *ngIf="section.value?.maxQuantity === section.value?.minQuantity; else atLeastN">
                      {{ t('CHOOSE_N', { n: section.value?.minQuantity }) }}
                    </ng-container>
                    <ng-template #atLeastN>
                      {{ t('CHOOSE_AT_LEAST_N', { n: section.value?.minQuantity }) }}
                    </ng-template>
                  </ng-container>
                  <ng-template #optional> {{ t('OPTIONAL') }} · {{ t('N_MAX', { n: section.value?.maxQuantity }) }} </ng-template>
                </div>
              </div>

              <div formArrayName="dishes">
                <div class="card-compact-list grid-desktop">
                  <div class="card" *ngFor="let dish of getDishes(i).controls; let j = index" [formGroupName]="j">
                    <div class="dish-container" (click)="onDishCardClick(section.value?.id, dish.value?.id)">
                      <div>{{ dish.value?.label }}</div>
                      <div class="spacer"></div>

                      <app-checkbox
                        valueType="number"
                        formControlName="quantity"
                        click-stop-propagation
                        [roundBorder]="section.value?.maxQuantity < 2"
                      ></app-checkbox>
                    </div>

                    <!-- <pre>{{dish.value | json}}</pre> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="cart-button-container" [class.update-formula]="cartFormula">
            <ion-button type="submit" color="primary" class="self-stretch desktop-centered ion-button-custom">
              <span class="button-text"> {{ cartFormula ? t('UPDATE_FORMULA') : t('ADD_FORMULA') }} </span>
              <app-currency [value]="formula.price" class="currency"></app-currency>
            </ion-button>
            <div *ngIf="cartFormula" class="delete-button mt-8" (click)="deleteFormula()">{{ t('DELETE_FORMULA') }}</div>
          </div>

          <div class="mt-24"></div>
        </form>
      </div>
    </div>
  </ion-content>
</ng-container>
